import {
  GET_PLC_STATUS,
  GET_PLC_STATUS_SUCCESS,
  GET_PLC_STATUS_ERROR,
} from "./actionTypes";

const initialState = {
  errorGetPlcStatus: "",
  loadingPlcStatus: false,
  plcStatus: null,
  successGetPlcStatus: "",
};

const getPlcStatus = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLC_STATUS:
      state = {
        ...state,
        loadingPlcStatus: true,
      };
      break;
    case GET_PLC_STATUS_SUCCESS:
      state = {
        ...state,
        loadingPlcStatus: false,
        plc_status: action.payload.plc_status,
        successGetPlcStatus: action.payload.message,
      };
      break;
    case GET_PLC_STATUS_ERROR:
      state = {
        ...state,
        errorGetPlcStatus: action.payload,
        loadingPlcStatus: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getPlcStatus;
